import gql from 'graphql-tag';

const eventFields = `
  id
  title
  description
  slug
  place {
    address {
      formatted
      city
      county
      stateLong
      stateShort
      countryLong
      countryShort
    }
  }
  startDate
  races {
    pricesFrom
    currencyLabel
    pricesTo
    standardTickets
    charityTickets
    bookingPartner {
      id
      value
    }
    tags {
      value
      link
    }
    races {
      information {
        sportLabel
        distanceLabel
        metricLength
      }
      tickets {
        currencyLabel
        tickets {
          charityTickets
          discountPrice
          rrp
          availability {
            type
          }
          charityDetails {
            title
            charityId
          }
          bookingEnabled
          isDeleted
        }
      }
      legDetails {
        id
        discipline
        distance
        distanceUnit
      }
    }
  }
  location {
    lat
    long
    address
  }
  images {
    hero {
      xxlarge
      xlarge
      large
      medium
      thumbnail
      original
      facebook
      twitter
      title
    }
  }
  reviewSummary {
    total
    ratings {
      overall
    }
  }
  tags
`;

const spotlightEventsFragment = gql`
  fragment SpotlightEventsFragment on Tag {
    spotlightEvents {
      title
      events {
        total
        events {
          title
          slug
          id
          startDate
          place {
            address {
              city
              countryShort
            }
          }
          reviews {
            total
            ratings {
              overall
            }
          }
          images {
            hero {
              medium
            }
          }
        }
      }
    }
  }
`;

const eventsEventSearchResultFragment = gql`
  fragment EventsFragment on EventSearchResult {
    total
    events {
      ${eventFields}
    }
    nearbyEvents {
      ${eventFields}
    }
  }
`;

const childFragment = gql`
  fragment ChildFragment on TagLink {
    labels {
      type
      value
    }
    type
    path
    content {
      pageInfo {
        images {
          type
          url
        }
      }
    }
    eventCount
  }
`;

const keyFilterFragment = gql`
  fragment keyFilterFragment on TagKeyFilter {
    label
    query
    eventCount
  }
`;

export const CategoryDataQuery = gql`
  query CategoryDataQuery(
    $path: String!
    $searchParameters: SearchParametersInput
  ) {
    categoryData: tagByRoute(path: $path, currentFilters: $searchParameters) {
      tag
      path
      type
      labels {
        type
        value
      }
      location {
        city
        state
        country
      }
      faqs {
        question
        answer
      }
      keyFilters {
        date(numMonths: 4) {
          ...keyFilterFragment
        }
      }
      query {
        tag
        sport
        sportDistance
        locationLat
        locationLong
        locationSearchRadius
        viewportNorthEastLat
        viewportSouthWestLat
        viewportNorthEastLong
        viewportSouthWestLong
        virtual
      }
      sport {
        id
        label
        distances {
          id
          label
        }
        tags {
          slug
          label
        }
      }
      distanceChildren: children(type: Distance) {
        ...ChildFragment
      }
      locationChildren: children(type: Location) {
        ...ChildFragment
      }
      parents {
        labels {
          type
          value
        }
        depth
        path
        type
      }
      content {
        meta {
          title
          description
          hrefLang {
            hreflang
            href
          }
        }
        pageInfo {
          title
          description
          shortDescription
        }
      }
      eventsV2(searchParams: $searchParameters) {
        ...EventsFragment
      }
      ...SpotlightEventsFragment
    }
  }
  ${eventsEventSearchResultFragment}
  ${spotlightEventsFragment}
  ${childFragment}
  ${keyFilterFragment}
`;

export const CategoryDataForEvent = gql`
  query CategoryDataForEvent(
    $latitude: Float
    $longitude: Float
    $sport: Int
    $sportDistance: Int
    $eventTags: [String]
    $countryCode: String
    $city: String
    $eventId: Int
  ) {
    categoryData: tagForEvent(
      eventId: $eventId
      input: {
        coordinates: { latitude: $latitude, longitude: $longitude }
        sport: $sport
        sportDistance: $sportDistance
        eventTags: $eventTags
        countryCode: $countryCode
        city: $city
      }
    ) {
      tag
      path
      type
      labels {
        type
        value
      }
      parents {
        labels {
          type
          value
        }
        depth
        path
      }
    }
  }
`;

export const SearchEventsV2 = gql`
  query SearchEventsV2($searchParametersInput: SearchParametersInput) {
    searchEventsV2(searchParameters: $searchParametersInput) {
      ...EventsFragment
    }
  }
  ${eventsEventSearchResultFragment}
`;
